import { useState, useEffect } from 'react';

interface FieldHintProps {
  text: string;
}

export function FieldHint({ text }: FieldHintProps) {
  const [show, setShow] = useState(false);

  // Same Escape-to-dismiss pattern used by HelpTip/Modal.
  useEffect(() => {
    if (!show) return;
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') setShow(false); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [show]);

  return (
    <span className="relative inline-block ml-1 align-middle">
      <span
        tabIndex={0}
        role="button"
        aria-label="Ayuda del campo"
        aria-expanded={show}
        className="p-3 rounded-full inline-flex items-center justify-center cursor-help hover:bg-brand-50 transition-colors"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        onClick={() => setShow((prev) => !prev)}
      >
        <span className="w-4 h-4 rounded-full bg-slate-200 text-slate-400 text-[10px] font-bold inline-flex items-center justify-center">
          ?
        </span>
      </span>
      {show && (
        <>
          {/* Same tap-outside-to-dismiss pattern used by HelpTip. */}
          <span className="fixed inset-0 z-20" onClick={() => setShow(false)} aria-hidden="true" />
          <span role="tooltip" className="absolute z-30 bottom-full left-1/2 -translate-x-1/2 mb-1 w-48 bg-slate-800 text-white text-xs rounded-lg px-2 py-1.5 shadow-lg">
            {text}
            <span className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-800" />
          </span>
        </>
      )}
    </span>
  );
}
